function QuienesSomos() {
  return (
    <div className="relative min-h-screen bg-background">
      <div className="watermark" aria-hidden="true"></div>
      <section className="page-hero h-64 md:h-80 flex items-center justify-center">
        <img
          src="/Docs/Fotos/Horcon foto.png"
          alt="Veterinario profesional en atención clínica"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary/60"></div>
        <h1 className="relative text-3xl md:text-4xl font-bold text-white">Quienes Somos — El Horcon Criollo</h1>
      </section>

      <section className="py-12 md:py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-text-primary mb-6">Historia</h2>
              <p className="text-text-secondary mb-4">
                El Horcon Criollo es una veterinaria profesional dedicada a la atención integral de animales de compañía y de producción. Nuestra trayectoria se construye sobre la base de la experiencia clínica, la capacitación continua y un trato ético y cercano con cada paciente y su familia.
              </p>
              <img
                src="/Docs/Fotos/Horcon foto.png"
                alt="Veterinario profesional en atención clínica"
                className="rounded-lg w-full h-64 object-cover"
                loading="lazy"
              />
            </div>

            <div>
              <h2 className="text-3xl font-bold text-text-primary mb-6">Misión</h2>
              <p className="text-text-secondary mb-6">
                Brindar atención veterinaria integral y profesional, combinando medicina preventiva, diagnóstico y tratamiento, con un enfoque humano y respetuoso hacia los animales y sus responsables.
              </p>

              <h3 className="text-2xl font-semibold text-text-primary mb-4">Visión</h3>
              <p className="text-text-secondary mb-6">
                Ser una veterinaria de referencia en la región, reconocida por la calidad de sus servicios, la trayectoria profesional de su equipo y la cercanía en el trato con cada familia animal.
              </p>

              <h3 className="text-2xl font-semibold text-text-primary mb-4">Valores Institucionales</h3>
              <ul className="space-y-2 text-text-secondary">
                <li className="flex items-center">
                  <i className="ph ph-check-circle text-primary mr-2"></i>
                  Profesionalismo y ética veterinaria
                </li>
                <li className="flex items-center">
                  <i className="ph ph-check-circle text-primary mr-2"></i>
                  Bienestar animal como prioridad
                </li>
                <li className="flex items-center">
                  <i className="ph ph-check-circle text-primary mr-2"></i>
                  Atención personalizada y respetuosa
                </li>
                <li className="flex items-center">
                  <i className="ph ph-check-circle text-primary mr-2"></i>
                  Prevención como pilar fundamental
                </li>
                <li className="flex items-center">
                  <i className="ph ph-check-circle text-primary mr-2"></i>
                  Educación continua y asesoramiento responsable
                </li>
                <li className="flex items-center">
                  <i className="ph ph-check-circle text-primary mr-2"></i>
                  Respeto por el vínculo entre animales y personas
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default QuienesSomos